import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import BackgroundSvg from './svgs/BackgroundSmall.svg';
import GreenLineUpSvg from './svgs/GreenLineUp.svg';
import GreenLineDownSvg from './svgs/GreenLineBottom.svg';
import { saveWorkshopProgress, markReplacementModalAsSeen } from '../../../../../actions/workshopActions';
import {
  ReplacementBackground, ReplacementTitleTextContainer, ReplacementTitleText,
  ReplacementGreenLineDown, ReplacementGreenLineUp, ReplacementDescriptionTextContainer,
  ReplacementDescriptionText,
} from './styledComponents';
import { ModalContainer } from '../sharedComponents/StyledComponents';
import { ActionButton } from '../../sharedStyledComponents/Components';

const RePlacementModal = ({ closeModal }) => {
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch(markReplacementModalAsSeen());
    dispatch(saveWorkshopProgress());
    closeModal();
  };

  return (
    <StyledContainer
      role="dialog"
      aria-modal="true"
      data-testid="replacement-modal"
      data-dd-action-name="workshop-replacement-modal"
    >
      <ReplacementBackground src={BackgroundSvg} alt="" />
      <ReplacementTitleTextContainer>
        <ReplacementTitleText data-testid="replacement-modal-title">
          NEW
        </ReplacementTitleText>
      </ReplacementTitleTextContainer>
      <ReplacementGreenLineUp src={GreenLineUpSvg} alt="" />
      <ReplacementDescriptionTextContainer>
        <ReplacementDescriptionText data-testid="replacement-modal-message">
          New data received. Games will be updated in your next quest. Keep going, you&apos;re growing!
        </ReplacementDescriptionText>
      </ReplacementDescriptionTextContainer>
      <ReplacementGreenLineDown src={GreenLineDownSvg} alt="" />
      <ContinueButton
        onClick={handleClick}
        data-testid="replacement-modal-continue-button"
        data-dd-action-name="workshop-replacement-modal:continue"
      >
        Continue
      </ContinueButton>
    </StyledContainer>
  );
};

RePlacementModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

export default RePlacementModal;

const ContinueButton = styled(ActionButton)`
  position: absolute;
  top: 340;
  left: 387;
`;

const StyledContainer = styled(ModalContainer)`
  position: absolute;
  top: 40px;
`;
